import { FunctionComponent, PropsWithChildren, useState } from 'react';

import ForceReRenderContext from './ForceReRenderContext';

const ForceReRenderProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [reRenderListener, setReRenderLister] = useState(false);

  function forceReRender() {
    setReRenderLister(!reRenderListener);
  }

  const value = {
    forceReRender,
    reRenderListener,
  };

  return <ForceReRenderContext.Provider value={value}>{children}</ForceReRenderContext.Provider>;
};

export default ForceReRenderProvider;
